// ============================================================================
// Shared Job Visibility Helpers
// ============================================================================

import type { Job } from "../../../../../../models";

/**
 * Gets a display name for a job (grower - field format)
 */
export function getJobDisplayName(job: Job): string {
	const grower = job.growerName || job.importGrowerName || "Unknown";
	const field = job.fieldName || job.importFieldName || "Unknown";
	return `${grower} - ${field}`;
}

/**
 * Formats an area from square meters to a human-readable string
 */
export function formatArea(squareMeters: number): string {
	const acres = squareMeters / 4046.86;
	if (acres < 0.01) {
		return `${squareMeters.toFixed(0)} sq meters`;
	}
	return `${acres.toFixed(2)} acres`;
}

/**
 * Creates a toggle function for managing visibility sets
 */
export function createVisibilityToggler(
	setter: React.Dispatch<React.SetStateAction<Set<string>>>,
): (id: string) => void {
	return (id: string) => {
		setter((prev) => {
			const next = new Set(prev);
			if (next.has(id)) {
				next.delete(id);
			} else {
				next.add(id);
			}
			return next;
		});
	};
}

/**
 * Creates show/hide all functions for visibility sets
 */
export function createShowHideAllHandlers(
	setter: React.Dispatch<React.SetStateAction<Set<string>>>,
	getIds: () => string[],
): { showAll: () => void; hideAll: () => void } {
	return {
		showAll: () => setter(new Set()),
		hideAll: () => setter(new Set(getIds())),
	};
}
